import React from 'react';
import styles from '../../../styles/EstudiantesStyles/Estudiantes.module.css';

const MEXICAN_STATES = [
  'Aguascalientes',
  'Baja California',
  'Baja California Sur',
  'Campeche',
  'Chiapas',
  'Chihuahua',
  'Ciudad de México',
  'Coahuila',
  'Colima',
  'Durango',
  'Estado de México',
  'Guanajuato',
  'Guerrero',
  'Hidalgo',
  'Jalisco',
  'Michoacán',
  'Morelos',
  'Nayarit',
  'Nuevo León',
  'Oaxaca',
  'Puebla',
  'Querétaro',
  'Quintana Roo',
  'San Luis Potosí',
  'Sinaloa',
  'Sonora',
  'Tabasco',
  'Tamaulipas',
  'Tlaxcala',
  'Veracruz',
  'Yucatán',
  'Zacatecas',
];

const InformacionGeneral = ({ values, onChange, student, mode = 'view' }) => {
  const isEditable = mode === 'create' || mode === 'edit';
  return (
    <div className={styles.tabPanel}>
      {/* Información Personal */}
      <div className={styles.infoSection}>
        <div className={styles.sectionHeader}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="#ed8b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H14C15.0609 15 16.0783 15.4214 16.8284 16.1716C17.5786 16.9217 18 17.9391 18 19V21" stroke="#ed8b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <h3 className={styles.sectionTitle}>Información Personal</h3>
          </div>
          {isEditable && (
            <span style={{ fontSize: '11px', color: '#dc2626', fontStyle: 'italic' }}>
              Los campos marcados con (*) son obligatorios
            </span>
          )}
        </div>
        <div className={styles.infoGrid}>
          <div className={styles.infoItem}>
            <span className={isEditable ? styles.requiredFieldLabel : styles.infoLabel}>Nombre Completo:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.nombre_completo}
                onChange={e => onChange('nombre_completo', e.target.value)}
                placeholder="Nombre completo"
                required
              />
            ) : (
              <span className={styles.infoValue}>{values.nombre_completo || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Información de Contacto:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.contacto}
                onChange={e => onChange('contacto', e.target.value)}
                placeholder="Ej. Madre / Padre / Tutor"
              />
            ) : (
              <span className={styles.infoValue}>{values.contacto || ''}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={isEditable ? styles.requiredFieldLabel : styles.infoLabel}>Fecha de nacimiento:</span>
            {isEditable ? (
              <input
                type="date"
                className={styles.studentFormInput}
                value={values.fecha_nacimiento}
                onChange={e => onChange('fecha_nacimiento', e.target.value)}
                required
              />
            ) : (
              <span className={styles.infoValue}>{values.fecha_nacimiento || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Email Personal:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.email_personal}
                onChange={e => onChange('email_personal', e.target.value)}
                placeholder="Email personal"
              />
            ) : (
              <span className={styles.infoValue}>{values.email_personal || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>CURP:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.curp}
                onChange={e => onChange('curp', e.target.value)}
                placeholder="CURP"
              />
            ) : (
              <span className={styles.infoValue}>{values.curp || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={isEditable ? styles.requiredFieldLabel : styles.infoLabel}>Lugar de nacimiento:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.lugar_nacimiento}
                onChange={e => onChange('lugar_nacimiento', e.target.value)}
                placeholder="Ciudad, Estado"
                required />
            ) : (
              <span className={styles.infoValue}>{values.lugar_nacimiento || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Teléfono:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.telefono_contacto}
                onChange={e => onChange('telefono_contacto', e.target.value)}
                placeholder="Teléfono de contacto" />
            ) : (
              <span className={styles.infoValue}>{values.telefono_contacto || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={isEditable ? styles.requiredFieldLabel : styles.infoLabel}>Género:</span>
            {isEditable ? (
              <select
                className={styles.studentFormInput}
                value={values.sexo}
                onChange={e => onChange('sexo', e.target.value)}
                required
              >
                <option value="">Selecciona...</option>
                <option value="M">Masculino</option>
                <option value="F">Femenino</option>
                <option value="O">Otro</option>
              </select>
            ) : (
              <span className={styles.infoValue}>
                {values.sexo === "M"
                  ? "Masculino"
                  : values.sexo === "F"
                  ? "Femenino"
                  : values.sexo === "O"
                  ? "Otro"
                  : "No disponible"}
              </span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Email Institucional:</span>
            {isEditable ? (
              <input
                type="email"
                className={styles.studentFormInput}
                value={values.email_institucional}
                onChange={e => onChange('email_institucional', e.target.value)}
                placeholder="correo.institucional@lux.edu" />
            ) : (
              <span className={styles.infoValue}>{values.email_institucional || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Estado Civil:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.estado_civil}
                onChange={e => onChange('estado_civil', e.target.value)}
                placeholder="Soltero, Casado, etc." />
            ) : (
              <span className={styles.infoValue}>{values.estado_civil || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Teléfono de emergencia:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.telefono_emergencia}
                onChange={e => onChange('telefono_emergencia', e.target.value)}
                placeholder="Teléfono de emergencia" />
            ) : (
              <span className={styles.infoValue}>{values.telefono_emergencia || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Nacionalidad:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.nacionalidad}
                onChange={e => onChange('nacionalidad', e.target.value)}
                placeholder="Mexicana, etc." />
            ) : (
              <span className={styles.infoValue}>{values.nacionalidad || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Email del padre/tutor:</span>
            {isEditable ? (
              <input
                type="email"
                className={styles.studentFormInput}
                value={values.email_tutor}
                onChange={e => onChange('email_tutor', e.target.value)}
                placeholder="correo del padre/tutor" />
            ) : (
              <span className={styles.infoValue}>{values.email_tutor || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>País de Origen:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.pais_origen}
                onChange={e => onChange('pais_origen', e.target.value)}
                placeholder="País de origen" />
            ) : (
              <span className={styles.infoValue}>{values.pais_origen || 'No disponible'}</span>
            )}
          </div>
        </div>
      </div>

      {/* Dirección */}
      <div className={styles.infoSection}>
        <div className={styles.sectionHeader}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="#ed8b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 22V12H15V22" stroke="#ed8b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <h3 className={styles.sectionTitle}>Dirección</h3>
        </div>
        <div className={styles.infoGrid}>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Calle y Número:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.calle}
                onChange={e => onChange('calle', e.target.value)}
                placeholder="Calle y número" />
            ) : (
              <span className={styles.infoValue}>{values.calle || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Estado:</span>
            {isEditable ? (
              <select
                className={styles.studentFormInput}
                value={values.estado_direccion || ''}
                onChange={e => onChange('estado_direccion', e.target.value)}
              >
                <option value="">– Seleccionar estado –</option>
                {MEXICAN_STATES.map((estado) => (
                  <option key={estado} value={estado}>{estado}</option>
                ))}
              </select>
            ) : (
              <span className={styles.infoValue}>{values.estado_direccion || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Colonia:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.colonia}
                onChange={e => onChange('colonia', e.target.value)}
                placeholder="Colonia" />
            ) : (
              <span className={styles.infoValue}>{values.colonia || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Código Postal:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.codigo_postal}
                onChange={e => onChange('codigo_postal', e.target.value)}
                placeholder="Código Postal" />
            ) : (
              <span className={styles.infoValue}>{values.codigo_postal || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Ciudad:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.ciudad}
                onChange={e => onChange('ciudad', e.target.value)}
                placeholder="Ciudad" />
            ) : (
              <span className={styles.infoValue}>{values.ciudad || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>País:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.pais || 'Mexico'}
                disabled
                placeholder="País" />
            ) : (
              <span className={styles.infoValue}>{values.pais || 'No disponible'}</span>
            )}
          </div>
        </div>
      </div>

      {/* Datos de los Padres o Tutores */}
      <div className={styles.infoSection}>
        <div className={styles.sectionHeader}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="#ed8b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="#ed8b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="#ed8b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="#ed8b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <h3 className={styles.sectionTitle}>Datos de los Padres o Tutores</h3>
        </div>
        <div className={styles.infoGrid}>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Nombre del Padre:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.nombre_padre}
                onChange={e => onChange('nombre_padre', e.target.value)}
                placeholder="Nombre completo del padre" />
            ) : (
              <span className={styles.infoValue}>{values.nombre_padre || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Ocupación del Padre:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.ocupacion_padre}
                onChange={e => onChange('ocupacion_padre', e.target.value)}
                placeholder="Ocupación o profesión" />
            ) : (
              <span className={styles.infoValue}>{values.ocupacion_padre || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Nombre de la Madre:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.nombre_madre}
                onChange={e => onChange('nombre_madre', e.target.value)}
                placeholder="Nombre completo de la madre" />
            ) : (
              <span className={styles.infoValue}>{values.nombre_madre || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Ocupación de la Madre:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.ocupacion_madre}
                onChange={e => onChange('ocupacion_madre', e.target.value)}
                placeholder="Ocupación o profesión" />
            ) : (
              <span className={styles.infoValue}>{values.ocupacion_madre || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Ingreso Mensual Familiar:</span>
            {isEditable ? (
              <input
                type="number"
                step="0.01"
                min="0"
                className={styles.studentFormInput}
                value={values.ingreso_mensual_familiar}
                onChange={e => onChange('ingreso_mensual_familiar', e.target.value)}
                placeholder="Ingreso mensual en pesos" />
            ) : (
              <span className={styles.infoValue}>
                {values.ingreso_mensual_familiar 
                  ? `$${parseFloat(values.ingreso_mensual_familiar).toLocaleString('es-MX', { minimumFractionDigits: 2 })}` 
                  : 'No disponible'}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Contacto de Pago (Responsable Financiero) */}
      <div className={styles.infoSection}>
        <div className={styles.sectionHeader}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="5" width="20" height="14" rx="2" stroke="#ed8b00" strokeWidth="2" />
            <path d="M2 10H22" stroke="#ed8b00" strokeWidth="2" />
          </svg>
          <h3 className={styles.sectionTitle}>Contacto de Pago (Responsable Financiero)</h3>
        </div>
        <div className={styles.infoGrid}>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Nombre Completo:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.nombre_responsable_financiero}
                onChange={e => onChange('nombre_responsable_financiero', e.target.value)}
                placeholder="Nombre del responsable financiero" />
            ) : (
              <span className={styles.infoValue}>{values.nombre_responsable_financiero || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Email:</span>
            {isEditable ? (
              <input
                type="email"
                className={styles.studentFormInput}
                value={values.email_responsable_financiero}
                onChange={e => onChange('email_responsable_financiero', e.target.value)}
                placeholder="Correo del responsable" />
            ) : (
              <span className={styles.infoValue}>{values.email_responsable_financiero || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Teléfono:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.telefono_responsable_financiero}
                onChange={e => onChange('telefono_responsable_financiero', e.target.value)}
                placeholder="Teléfono del responsable" />
            ) : (
              <span className={styles.infoValue}>{values.telefono_responsable_financiero || 'No disponible'}</span>
            )}
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Dirección Completa:</span>
            {isEditable ? (
              <input
                className={styles.studentFormInput}
                value={values.direccion_responsable_financiero}
                onChange={e => onChange('direccion_responsable_financiero', e.target.value)}
                placeholder="Dirección completa del responsable" />
            ) : (
              <span className={styles.infoValue}>{values.direccion_responsable_financiero || 'No disponible'}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InformacionGeneral;
